module.exports = __webpack_public_path__ + "media/images/kids10-ccdd776bc5df061d426656c4adb25308.jpg";